import { Timestamp } from 'firebase/firestore';

export const parseFirestoreTimestamp = (
  timestamp: Timestamp | { seconds: number; nanoseconds: number } | null | undefined,
): { date: string; time: string } | null => {
  if (!timestamp) return null;

  let date: Date;
  if (timestamp instanceof Timestamp) {
    date = timestamp.toDate();
  } else {
    date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1_000_000);
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dateString = `${year}-${month}-${day}`;

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const timeString = `${hours}:${minutes}:${seconds}`;

  return { date: dateString, time: timeString };
};
